'use client';

import React from 'react';
import { CookieContextProvider } from './context/cookie-context';
import { ContactUsFromContextProvider } from './context/contact-us-context';
import { LocaleProvider } from './context/locale-context';
import { SmoothScrollingContextProvider } from './context/smooth-scrolling-context';
import { TransitionContextProvider } from './context/transition-context';

// 导出所有individual providers
export { CookieContextProvider } from './context/cookie-context';
export { ContactUsFromContextProvider } from './context/contact-us-context';
export { LocaleProvider } from './context/locale-context';
export { SmoothScrollingContextProvider } from './context/smooth-scrolling-context';
export { TransitionContextProvider } from './context/transition-context';

// 导出所有hooks
export { default as useCookieContext } from './context/cookie-context';
export { default as useContactUsContext } from './context/contact-us-context';
export { useLocale } from './context/locale-context';

// 统一的Provider组合组件
interface AppProvidersProps {
    children: React.ReactNode;
    locale: string;
}

export function AppProviders({ children, locale }: AppProvidersProps) {
    return (
        <LocaleProvider locale={locale}>
            <CookieContextProvider>
                <SmoothScrollingContextProvider>
                    <ContactUsFromContextProvider>
                        <TransitionContextProvider>
                            {children}
                        </TransitionContextProvider>
                    </ContactUsFromContextProvider>
                </SmoothScrollingContextProvider>
            </CookieContextProvider>
        </LocaleProvider>
    );
}

// 简化版的Provider组合（不包含所有context）
interface CoreProvidersProps {
    children: React.ReactNode;
    locale: string;
}

export function CoreProviders({ children, locale }: CoreProvidersProps) {
    return (
        <LocaleProvider locale={locale}>
            <ContactUsFromContextProvider>
                {children}
            </ContactUsFromContextProvider>
        </LocaleProvider>
    );
}
